import { render } from "./Rappel.vue?vue&type=template&id=fc426458"
import script from "./Rappel.vue?vue&type=script&lang=js"
export * from "./Rappel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Modal/Questionnaire/Rappel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fc426458"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fc426458', __exports__)) {
    api.reload('fc426458', __exports__)
  }
  
  module.hot.accept("./Rappel.vue?vue&type=template&id=fc426458", () => {
    api.rerender('fc426458', render)
  })

}


export default __exports__